@if (showSearch() || !hasFilterableHeaders()) {
  <div class="d-flex justify-content-between align-items-center">
    @if (showSearch()) {
      <div class="d-flex justify-content-start mb-3">
        <ap-search
          styleClass="p-0"
          [placeholder]="'admin.grid.searchFieldPlaceholder' | translate"
          searchType="primary"
          (onSearch)="search($event)" />
      </div>
    }

    <div class="d-flex justify-content-end mb-3">
      <ap-button
        icon="plus-outline"
        [add]="true"
        (onClick)="createActionClick()" />
    </div>
  </div>
}
<gstar-prime-grid
  #grid
  [source]="source().items"
  [totalRows]="source().total"
  [isLoading]="isLoading()"
  [headers]="headers()"
  [settings]="setting"
  (queryChange)="queryHandler($event)"
  (selectRows)="selectRows.emit($event)">
  @if (!showSearch() && hasFilterableHeaders()) {
    <div end-toolbar>
      <ap-button
        icon="plus-outline"
        [add]="true"
        (onClick)="createActionClick()" />
    </div>
  }
</gstar-prime-grid>

@if (showDrawer()) {
  <ap-drawer
    [visible]="!!selectedDrawerType"
    placement="right"
    [mask]="false"
    [drawerTitle]="selectedDrawerType?.title ?? ''"
    [resizable]="false"
    (onClose)="drawerCloseClick()">
    @if (selectedDrawerType) {
      <ng-container
        *ngComponentOutlet="
          selectedDrawerType.component;
          inputs: selectedDrawerType.componentInputs
        " />
    }
    <ng-template ngTemplate="footer">
      <div class="d-flex gap-2">
        @for (button of selectedDrawerType?.buttons; track button) {
          <ap-button
            [btnType]="button.isPrimary ? 'primary' : 'secondary'"
            (onClick)="
              button.command?.(drawerCloseClick.bind(this), selectedDrawerData!)
            "
            [disabled]="button.isPrimary ? !selectedDrawerData?.isValid : false"
            [label]="button.label" />
        }
      </div>
    </ng-template>
  </ap-drawer>
}
